module.exports = __webpack_public_path__ + "static/media/bg-login.6bd5ee76.jpg";